
import { z } from "zod";

export const QaTradeDecisionValues = ["CORRECTIONS_NEEDED", "FLAGGED_CONCERN", "NO_CORRECTIONS_NEEDED"] as const;
export const QaTradeDecisionSchema = z.enum(QaTradeDecisionValues);
export const QaTradeDecision = QaTradeDecisionSchema.enum;
export type QaTradeDecision = (typeof QaTradeDecisionValues)[number];
export const QaTradeDecisionDisplayNames = { "CORRECTIONS_NEEDED": "Corrections Needed",
"FLAGGED_CONCERN": "Flagged Concern",
"NO_CORRECTIONS_NEEDED": "No Corrections Needed", } satisfies Record<QaTradeDecision, string>;
